export default __webpack_public_path__ + "static/media/InParis.2649d226.png";